import pxToRem from "../../functions/pxToRem";

export default function cardMedia({ borders }) {
  const { borderRadius } = borders;

  const cardMedia = {
    styleOverrides: {
      root: {
        borderRadius: borderRadius.xl,
        margin: `${pxToRem(16)} ${pxToRem(16)} 0`,
      },

      media: {
        width: "auto",
      },
    },
  };

  return cardMedia;
}
